"use strict";

import slideContentB from "./slider.content-module-b.js";
import slideContentBNav from "./slider.content-module-b-nav.js";
import slideSecondaryNews from "./slider.secondary-news.js";
import solutionModuleE from "./slider.solution-module-e.js";
import customerReferencesA from "./slider.customer-references-a.js";
import customerReferencesB from "./slider.customer-references-b.js";
import priceSlider from "./slider.price-slider.js";
import timeline from "./slider.timeline.js";
import solutionModuleC1 from "./slider.solution-module-c1.js";
import carouselA from "./slider.carousel-a.js";

export default {
    slideContentB,
    slideContentBNav,
    slideSecondaryNews,
    solutionModuleE,
    customerReferencesA,
    customerReferencesB,
    priceSlider,
    timeline,
    solutionModuleC1,
    carouselA,
};
